var DownloadInvoiceError = /* @__PURE__ */ ((DownloadInvoiceError2) => {
  DownloadInvoiceError2["GENERIC_ERROR"] = "GENERIC_ERROR";
  DownloadInvoiceError2["INVALID_CUSTOMER_INFO"] = "INVALID_CUSTOMER_INFO";
  DownloadInvoiceError2["INVALID_ORDER_STATUS"] = "INVALID_ORDER_STATUS";
  DownloadInvoiceError2["ORDER_NOT_INVOICED"] = "ORDER_NOT_INVOICED_YET";
  DownloadInvoiceError2["ORDER_NOT_BELONG_TO_CUSTOMER"] = "ORDER_NOT_BELONG_TO_CUSTOMER";
  return DownloadInvoiceError2;
})(DownloadInvoiceError || {});
export {
  DownloadInvoiceError
};
//# sourceMappingURL=types.js.map
